import { isSSR } from 'js/isSSR'

export const DecodeHTML = html => {
  if (isSSR) return html
  else {
    var txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }
}
